export default __webpack_public_path__ + "static/media/policyCorrection.521ca15a.svg";